import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

class EvolutionFilter extends Component {
  constructor(props) {
    super(props)
    const {
      intl: { formatMessage }
    } = props

    this.formatMessage = formatMessage

    this.select = React.createRef()
  }

	handleChange = () => {
	  if (this.select.current.selectedOptions) {
	    if (this.select.current.selectedOptions.length > 0) this.props.fn(this.select.current.selectedOptions[0].value)
	  } else {
	    // For compatibility with IE11
	    this.props.fn(this.select.current.value)
	  }
	}

	componentDidMount() {
	  this.handleChange()
	}

	renderIfAllOK() {
	  let options = []
	  let renderingComponent = null
	  for (let i = 1; i < 11; i++) {
	    let option = (
	      <option key={i} value={i}>
	        {this.formatMessage(messages.option, { years: i })}
	      </option>
	    )
	    options.push(option)
	  }
	  renderingComponent = (
	    <React.Fragment>
	      <label htmlFor="select02">{this.props.label}</label>
	      <select ref={this.select} onChange={this.handleChange} className="form-control" id="select02">
	        {options}
	      </select>
	    </React.Fragment>
	  )
	  return renderingComponent
	}

	render() {
	  return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(EvolutionFilter)



// WEBPACK FOOTER //
// ./src/modules/Filters/EvolutionFilter/EvolutionFilter.jsx